export default "__VITE_ASSET__63aa1294__"